// 消費者画面・Deviseログイン画面・トップ/エラーページ用（Vue なし）
// rails-ujs: data-method / data-confirm / data-remote などの Rails 標準 UJS
import Rails from '@rails/ujs'

Rails.start()
